const { subDays, format } = require("date-fns");

function getPast10Dates({ currentDate }) {
  const pastDates = [];
  let date = new Date(currentDate);

  for (let i = 0; i < 10; i++) {
    date = subDays(date, 1);
    pastDates.unshift({
      date: format(date, "yyyy-MM-dd"),
      day: format(date, "EEEE"),
      month: format(date, "MMMM"),
    });
  }

  return pastDates;
}

exports.getPast10Dates = getPast10Dates;
